import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiRepository, Result } from '@softline/core';
import { LagerlistenVerbrauchState } from '../data/verbrauch';
import { SOFTLINE_API_ROHSTOFFBEREITSTELLUNG_QUERY } from '../rohstoffbereitstellung.api';
import { RohstoffbereitstellungQuery } from '../services/query.service';

@Injectable()
export class LagerlistenVerbrauchRepository extends ReadonlyHttpApiRepository<
  Result<LagerlistenVerbrauchState>,
  RohstoffbereitstellungQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ROHSTOFFBEREITSTELLUNG_QUERY);
  }

  protected override getLoadPayload(
    params: RohstoffbereitstellungQuery
  ): unknown | undefined {
    return params;
  }
}
